import {isEmpty} from 'lodash'
import {http} from '../../axios'
import router from "../../router";
import Vue from "vue";
import sectionBase from "./sectionBase";
import sectionRequirements from "./sectionRequirements";
import sectionDescription from "./sectionDescription";
import sectionAdditionalQuestions from "./sectionAdditionalQuestions";
import translate from "../../helpers/translate"

const yesOrNo = [{
  id: true,
  name: 'Yes'
}, {
  id: false,
  name: 'No'
}]

const otherDocuments = {
  id: 'other',
  name: 'Other documents'
}

const ageTypes = [
  {
    id: true,
    name: 'Any age'
  },
  {
    id: false,
    name: 'Set age'
  }
]

const ageMin = 18
const ageMax = 100

function translateSettings(arr, key) {
  return arr.map(item => {
    item.name = translate(item.name, null, key)
    return item
  })
}

function getInitState() {
  return {
    muted: false,
    loaded: false,
    pendingLoad: false,
    pendingSave1: false,
    pendingSave2: false,
    vacancy: null,
    duplicateId: null,

    //SETTINGS
    ageMin,
    ageMax,
    pendingLoadSettings: false,
    salaryTypes: null,
    salaryPayoutTypes: null,
    workPeriods: null,
    workContracts: null,
    workContractSubItems: null,
    scheduleWorkDurations: null,
    personTypes: null,
    documentsForStart: null,
    experienceRequirement: null,
    languageLevel: null,
    physicalActivities: null,
    educationLevels: null,
    additionalDocuments: null,
    conditionsType: null,
    employmentTypes: null,
    yesOrNo: null,
    otherDocuments: null,
    ageTypes: null,
    locationsPriority: null,

    justCreated: false,
    afterJustCreated: false,
    savedBlocks: { 1: false, 2: false, 3: false, 4: false },
    originalLocale: null,
  }
}

export default {
  namespaced: true,
  modules: {
    sectionBase,
    sectionRequirements,
    sectionDescription,
    sectionAdditionalQuestions,
  },
  state: getInitState(),
  getters: {
    yesOrNo(state) {
      return state.yesOrNo
    },
    otherDocuments(state) {
      return state.otherDocuments
    },
    ageTypes(state) {
      return state.ageTypes
    },
    savedBlocks(state) {
      return state.savedBlocks;
    },
    justCreated(state) {
      return state.justCreated;
    },
    afterJustCreated(state) {
      return state.afterJustCreated;
    },
    originalLocale(state) {
      return state.originalLocale;
    },
    allInputs(state) {
      return {
        ...state.sectionBase.inputs,
        ...state.sectionDescription.inputs,
        ...state.sectionRequirements.inputs,
        ...state.sectionAdditionalQuestions.inputs,
      };
    },
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setVacancy(state, data) {
      Vue.set(state, 'vacancy', data)
    }
  },
  actions: {
    setStaticLists({commit}) {
      commit('setProperty', ['yesOrNo', translateSettings(yesOrNo, 'newVacancy2')])
      commit('setProperty', ['otherDocuments', translateSettings([otherDocuments], 'newVacancy2')[0]])
      commit('setProperty', ['ageTypes', translateSettings(ageTypes, 'newVacancy2')])
    },
    resetState({commit}) {
      commit('resetState')
      commit('sectionBase/resetState')
      commit('sectionRequirements/resetState')
      commit('sectionDescription/resetState')
      commit('sectionAdditionalQuestions/resetState')
    },
    setDefaultJustCreated({ commit }) {
      commit('setProperty', ['justCreated', false]);
    },
    async getLanguagesPopup({ state }) {
      try {
        const { data } = await http.get(`/api/new-vacancy/${state.vacancy.id}/language-popups`);
        return data?.data;
      } catch {
        return false;
      }
    },
    saveVacancy({state, commit, rootState}, { publish = false, forceTranslate }) {
      const pendingSaveKey = publish ? 'pendingSave2' : 'pendingSave1';
      if (state[pendingSaveKey]) return;

      commit('setProperty', [pendingSaveKey, true])
      const vacancyId = state.vacancy && state.vacancy.id

      // const sendData = getters[`sectionDescription/sendData`]

      const translate_additional_questions = rootState.user.isOur ? sectionAdditionalQuestions.state.translateAdditionalQuestions : undefined;

      return http.post(`api/new-vacancy/${vacancyId}/post`, {
        send_to_moderator: publish,
        force_translate: forceTranslate,
        duplicate: Boolean(state.duplicateId),
        translate_additional_questions,
      }).then(({ data }) => {
        switch (data.data.redirect_to) {
          case 'published': router.push({ name: 'account-vacancies' }); break;
          case 'hidden': router.push({ name: 'account-vacancies-hidden' }); break;
          case 'profile': router.push({ name: 'account-employer-profile-edit' }); break;
          default: router.push({ name: 'account-vacancies' }); break;
        }

        if (data.data.popup) {
          Vue.prototype.$vModal.open('message', {
            title: data.data.popup.text,
            image: data.data.popup.image,
            btnText: data.data.popup.button,
            buttonCenter: true,
          });
        }
      }).catch(err => {
        // TODO temporary view
        console.log('Save status:', err.response.data.message);
      }).finally(() => {
        commit('setProperty', [pendingSaveKey, false])
      })
    },
    saveSection({state, getters, commit, dispatch}, { sectionName }) {
      commit('setProperty', ['pendingSave', true])
      const sectionId = state[sectionName].sectionId

      const vacancyId = state.vacancy && state.vacancy.id
      const additionalUrl = vacancyId ? `${vacancyId}/${sectionId}` : 'add'
      const sendData = getters[`${sectionName}/sendData`]

      const setFieldsErrors = data => {
        if (data.message) {
          dispatch(sectionName + '/setSectionErrors', { errors: data.message, sectionName })
        }
      };

      return http.post('api/new-vacancy/' + additionalUrl, sendData).then(({ data, status }) => {
        if (status === 201) {
          commit('setProperty', ['justCreated', true]);
          commit('setProperty', ['afterJustCreated', true]);
        }

        commit('setVacancy', { id: data.data.vacancy_id || vacancyId });

        commit('setProperty', ['savedBlocks', data.data.saved_blocks]);

        if (data.message === 'SAVED') {
          commit(sectionName + '/setProperty', ['saved', true]);

          const receivedVacancyId = data.data && data.data.vacancy_id

          if (receivedVacancyId && (
            !router.currentRoute.query.vacancy
            || router.currentRoute.query.vacancy.toString() !== receivedVacancyId.toString())
          ) {
            router.replace({query: {vacancy: receivedVacancyId}})
          }
        }

        setFieldsErrors(data);

        return data;
      }).catch(e => {
        setFieldsErrors(e.response.data);
      }).finally(() => {
        commit('setProperty', ['pendingSave', false])
      })
    },
    saveAfterDuplicate({dispatch}) {
      return dispatch('saveSection', {sectionName: 'sectionBase'})
        .then(() => {
          return Promise.all([
            dispatch('saveSection', {sectionName: 'sectionRequirements'}),
            dispatch('saveSection', {sectionName: 'sectionDescription'}),
            dispatch('sectionDescription/uploadAfterDuplicate')
          ])
        })
    },
    mainSettingsLoad({commit}, {vacancyId, duplicate}) {
      return http.get(`api/new-vacancy/data${vacancyId ? '/' + vacancyId : ''}`).then(({data}) => {
        commit('setProperty', ['savedBlocks', data.data.saved_blocks]);
        commit('setProperty', ['originalLocale', data.data.original_locale]);

        const lists = data.data.data_lists
        commit('setProperty', ['salaryTypes', lists.salary_type])
        commit('setProperty', ['salaryPayoutTypes', lists.salary_payout_type])
        commit('setProperty', ['workPeriods', lists.work_period])
        commit('setProperty', ['workContracts', lists.work_contract])
        commit('setProperty', ['workContractSubItems', lists.work_contract_subitem])
        commit('setProperty', ['scheduleWorkDurations', lists.schedule_work_duration])
        commit('setProperty', ['personTypes', lists.person_types])
        commit('setProperty', ['documentsForStart', lists.documents_for_start])
        commit('setProperty', ['experienceRequirement', lists.experience_requirement])
        commit('setProperty', ['languageLevel', lists.resume_language_level])
        commit('setProperty', ['physicalActivities', lists.physical_activity])
        commit('setProperty', ['educationLevels', lists.resume_education_level])
        commit('setProperty', ['additionalDocuments', lists.additional_documents])
        commit('setProperty', ['conditionsType', lists.conditions_type])
        commit('setProperty', ['employmentTypes', lists.vacancy_edit_employment_types])
        commit('setProperty', ['locationsPriority', lists.priority_by_location_of_the_candidate])

        if (!data.data.vacancy_data) return

        commit('setVacancy', {
          id: duplicate ? null : data.data.vacancy_data['1'].vacancy_id,
          vacancy: data.data.vacancy_data
        })

        if(duplicate) {
          commit('setProperty', ['duplicateId', vacancyId])
        }

        //SECTION 1
        if (!isEmpty(data.data.vacancy_data['1'])) {
          commit('sectionBase/setInputsAll', data.data.vacancy_data)
        }

        //SECTION 2
        if (!isEmpty(data.data.vacancy_data['2'])) {
          commit('sectionRequirements/setInputsAll', data.data.vacancy_data)
        }

        //SECTION 3
        if (!isEmpty(data.data.vacancy_data['3'])) {
          commit('sectionDescription/setInputsAll', data.data.vacancy_data)
        }

        //SECTION 4
        if (!isEmpty(data.data.vacancy_data['4'])) {
          commit('sectionAdditionalQuestions/setInputsAll', data.data.vacancy_data)
        }
      })
    },
    settingsLoad({state, commit, dispatch}, {vacancyId, duplicate, disablePending}) {
      if (state.pendingLoadSettings) return
      if (!disablePending) commit('setProperty', ['pendingLoadSettings', true])

      return Promise.all([
        dispatch('mainSettingsLoad', {vacancyId, duplicate}),
      ])
        .then(() => {
          if (duplicate) {
            return dispatch('saveAfterDuplicate')
          }
        })
        .finally(() => {
          if (!disablePending) commit('setProperty', ['pendingLoadSettings', false])
        })
    }
  }
}
//
// function createSettingLoad(key, storeKey, commit) {
//   return http.get(`/api/helper/selectbox/${key}`).then(({data}) => {
//     commit('setProperty', [storeKey, data.data])
//   })
// }
